import { useEffect } from 'react';
import { useQuery, useQueryClient } from '@tanstack/react-query';
import { isSupabaseConfigured } from '@/services/supabase-client.service';
import {
    getRequestStats,
    subscribeToRequests,
} from '@/services/care-practice-request.service';

export const practiceRequestKeys = {
    all: ['practice-requests'] as const,
    stats: (facilityId?: string) => [...practiceRequestKeys.all, 'stats', facilityId].filter(Boolean),
};

export function usePracticeRequestStatsQuery(facilityId?: string) {
    const queryClient = useQueryClient();

    useEffect(() => {
        if (!facilityId || !isSupabaseConfigured()) return;

        const sub = subscribeToRequests(facilityId, () => {
            void queryClient.invalidateQueries({
                queryKey: practiceRequestKeys.stats(facilityId),
            });
        });

        return () => sub.unsubscribe();
    }, [facilityId, queryClient]);

    return useQuery({
        queryKey: practiceRequestKeys.stats(facilityId),
        queryFn: () => getRequestStats(facilityId!),
        enabled: !!facilityId,
        staleTime: 30_000,
    });
}
